import axios from '../common/axios';
import { Grant, PermissionInfo, Place, Role } from './model';

const SERVICE_PREFIX = 'acl';

async function getAllRoles(): Promise<Role[]> {
  return axios.get(`${SERVICE_PREFIX}/roles`).then((res) => res.data);
}

async function createRole(data: any): Promise<any> {
  return axios.post(`${SERVICE_PREFIX}/role`, data).then((res) => res.data);
}

async function deleteRole(roleId: number): Promise<any> {
  return axios.delete(`${SERVICE_PREFIX}/role/${roleId}`).then((res) => res.data);
}

async function getAllPlaces(): Promise<Place[]> {
  return axios.get(`${SERVICE_PREFIX}/places`).then((res) => res.data);
}

async function refreshPlaceSeeds(): Promise<void> {
  return axios.post(`service/updatePlaces`).then((res) => res.data);
}

async function getAllGrants(): Promise<Grant[]> {
  return axios.get(`${SERVICE_PREFIX}/grants`).then((res) => res.data);
}

async function refreshGrantSeeds(): Promise<void> {
  return axios.post(`service/updateGrants`).then((res) => res.data);
}

async function getUserPermissions(placeCode: string | undefined): Promise<PermissionInfo> {
  return axios.get(`${SERVICE_PREFIX}/rightsByLocation/${placeCode}`).then(({ data }) => ({
    canAccessReport: data.canSee,
    canUpdateFigures: data.canEdit,
    canUpdateSources: data.canEditSources,
    canSubmitTarget: data.canEdit,
    canApproveTarget: data.canApprove,
    canApproveDivisionalTarget: data.canApproveDivisional,
  }));
}

export {
  getAllRoles,
  createRole,
  deleteRole,
  getAllPlaces,
  getAllGrants,
  getUserPermissions,
  refreshPlaceSeeds,
  refreshGrantSeeds,
};
